import { SchedulerV3 } from '@frontend/api-schedule-v3';
import { isEmpty } from '@frontend/validation';
import { ScheduleRequestListItem } from '../../../../../../../types';
import { PreferenceBasedScheduleRequestDetails } from './preference-based-request-item-details';
import { ScheduleRequestItemDetails } from './request-item-details';

interface ScheduleRequestDetailsProps {
  listItem: ScheduleRequestListItem;
  scheduleRequestId: string;
  requestVersion: string;
  locationId: string;
  isPaymentsEnabled: boolean;
}

export const ScheduleRequestDetails = ({
  listItem,
  scheduleRequestId,
  requestVersion,
  locationId,
  isPaymentsEnabled,
}: ScheduleRequestDetailsProps) => {
  const { isPreferenceBasedRequestEnabled } = SchedulerV3.Helpers.useGetPreferenceBasedRequestFeatureFlagDetails();
  const isPreferenceBasedRequest = !isEmpty(listItem.bookingDetails);

  if (isPreferenceBasedRequestEnabled && isPreferenceBasedRequest) {
    return <PreferenceBasedScheduleRequestDetails listItem={listItem} />;
  }

  return (
    <ScheduleRequestItemDetails
      scheduleRequestId={scheduleRequestId}
      requestVersion={requestVersion}
      locationId={locationId}
      isPaymentsEnabled={isPaymentsEnabled}
    />
  );
};
